import { isValidPhoneNumber } from 'libphonenumber-js';
import { parsePhoneNumberWithError } from 'libphonenumber-js/max';

export const isPhoneValid = (phone: string | undefined): boolean => {
    if (!phone) {
        return false;
    }
    if (!isValidPhoneNumber(phone)) {
        return false;
    }
    try {
        const phoneNumber = parsePhoneNumberWithError(phone, {
            defaultCountry: 'FR'
        });
        return phoneNumber.getType() == 'MOBILE';
    } catch (error) {
        return false;
    }
};
